import { render, staticRenderFns } from "./StatsMG.vue?vue&type=template&id=11959e74&"
import script from "./StatsMG.vue?vue&type=script&lang=js&"
export * from "./StatsMG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports